(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .filter('secondsToHoursMinutesSeconds', secondsToHoursMinutesSeconds);

  /** @ngInject */
  function secondsToHoursMinutesSeconds($filter) {
    return function (seconds) {
      if (!seconds) {
        return '00:00:00:00';
      }

      seconds = Number(seconds);
      var d = Math.floor(seconds / (3600 * 24));
      var h = Math.floor((seconds % (3600 * 24)) / 3600);
      var m = Math.floor((seconds % 3600) / 60);
      var s = Math.floor(seconds % 60);
      return (
        $filter('zeroPaddingFilter')(d, 2) +
        ':' +
        $filter('zeroPaddingFilter')(h, 2) +
        ':' +
        $filter('zeroPaddingFilter')(m, 2) +
        ':' +
        $filter('zeroPaddingFilter')(s, 2)
      );
    };
  }
})();
